<template>
    <div class="cart">
        <div class="progress" v-if="lang=='fr'">
            <h1>Votre Panier</h1>
            <div class="active">Votre commande</div>
            <div>Facturation et livraison</div>
            <div>Récapitulatif</div>
        </div>
        <div v-if="nbItems == 0 && lang =='fr'">
            Il n'y a aucun article dans votre panier.
        </div>
        <table class="cart-items" v-if="nbItems > 0 && lang=='fr'">
            <thead>
            <tr>
                <th>Désignation</th>
                <th>Prix unitaire</th>
                <th>Quantité</th>
                <th colspan="2">Prix TTC</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item in items">
                <td>{{ item.labelFR }}</td>
                <td>{{ item.price / 100 }} €</td>
                <td>
                    <input type="number" @change="editItem(item, $event)" :value="item.quantity" min="1" max="10" />
                <td>
                    {{ subtotal(item) / 100 }} €</td>
                <td><button class="remove" title="Supprimer l'article"  @click="removeItem(item)"></button></td>
            </tr>
            <tr class="sum">
                <td colspan="3">Total TTC</td>
                <td colspan="2">{{ totalPrice / 100 }} €</td>
            </tr>
            </tbody>
            <tfoot>
            <tr>
                <td colspan="3">Total HT</td>
                <td colspan="2">{{ totalNoVAT / 100 }} €</td>
            </tr>
            <tr>
                <td colspan="3">TVA (20%)</td>
                <td colspan="2">{{ totalVAT / 100 }} €</td>
            </tr>
            </tfoot>
        </table>


        <div v-if="nbItems == 0 && lang =='en'">
            Your cart is empty
        </div>

        <table class="cart-items"  v-if="lang=='en'">
            <thead>
            <tr>
                <th>Designation</th>
                <th>Unit Price</th>
                <th>Quantity</th>
                <th colspan="2">Sub-total</th>
            </tr>
            </thead>
            <tbody>
                <tr v-for="item in items">
                    <td>{{ item.labelEN }}</td>
                    <td>{{ item.price / 100}} €</td>
                    <td>
                        <input type="number" @change="editItem(item, $event)" :value="item.quantity" min="1" max="10" />

                    <td>
                        {{ subtotal(item) / 100 }} €</td>
                    <td><button class="remove" title="Remove this line" @click="removeItem(item)"></button></td>
                </tr>
                <tr class="sum">
                    <td colspan="3">Total Inc. VAT</td>
                    <td colspan="2">{{ totalPrice / 100 }} €</td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <td colspan="3">Total Exc. VAT</td>
                    <td colspan="2">{{ totalNoVAT / 100 }} €</td>
                </tr>
                <tr>
                    <td colspan="3">VAT (20%)</td>
                    <td colspan="2">{{ totalVAT / 100 }} €</td>
                </tr>
            </tfoot>
        </table>

        <section>
            <button v-if="lang=='fr'" :disabled="! isValid()" @click="nextStep()" class="submit next focus">Valider</button>
            <button v-if="lang=='en'" :disabled="! isValid()" @click="nextStep()" class="submit next focus">Submit</button>
        </section>

    </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'Cart',
    props: ['lang'],
    methods: {
      subtotal(item) {
        return item.quantity * item.price;
      },
      editItem(item, event) {
        const quantity = event.target.value;
        this.$store.commit('EDIT_ITEM', Object.assign(item, { quantity }));
      },
      removeItem(item) {
        this.$store.commit('REMOVE_ITEM', item);
      },
      isValid() {
        return this.nbItems > 0;
      },
      nextStep() {
        const routes = this.$router.options.routes;
        const routeToUser = this.$router.options.getRouteByName(routes, `Billing${this.lang.toUpperCase()}`);
        if (routeToUser) {
          this.$router.push(routeToUser);
        }
      },
    },
    computed: {
      ...mapGetters([
        'items', 'totalVAT', 'totalPrice', 'totalNoVAT', 'nbItems',
      ]),
    },
  };
</script>


<style lang="scss">
    .cart {
        padding: 0 2rem 2rem 2rem !important;
        max-width: 900px;
        background: url('../assets/order_bg.png') no-repeat center;
        background-size: cover;
        margin:auto;


        .progress {
            color:white;
            counter-reset: progress-counter;

            @media (max-width:42rem) {
                padding-top:4rem;
            }

            h1 {
                color:white;
                text-transform: uppercase;
                text-shadow: 1px 1px #333;
                display: inline-block;
            }
            > div {
                display: inline-block;
                padding:.5rem 1rem;

                &.active {
                    color:#9c554b;
                }

                &:before{
                    counter-increment: progress-counter +1;
                    content: counter(progress-counter) ;
                    background-color: white;
                    color: #654a45;
                    padding:0.1rem .5rem;
                    border-radius:50%;
                    border:1px gray solid;
                    margin-right:0.5rem;
                }
            }
        }

        input[type='number'] {
            width:50px;
            text-align: center;
            background-color: #ebe9e8;
        }



        .remove {
            background: url('../assets/cart_remove.png') no-repeat center;
            vertical-align: middle;
            width: 17px;
            height: 19px;
            border:1px transparent solid;
            margin:5px;
            &:hover {
                border-color: #654a45;
                cursor: pointer;
            }
        }


        @media (max-width: 42em) {
            section {
                display: block;
                margin:1rem 0 3rem 0;
            }
        }
        .submit.next {
            float: right;
        }
    }


</style>



// WEBPACK FOOTER //
// src/components/CartPage.vue